module.exports = __webpack_public_path__ + "static/media/5.4d45f602.jpg";